export default "__VITE_ASSET__983108ee__"